(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["v-google-translate"] = factory();
	else
		root["v-google-translate"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 